/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Sched_Desc5Inputs */

const en_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrapes that run on a cadence and deliver fresh data on time, daily, weekly, or event-triggered.`)
};

const ar_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمليات سحب تعمل بإيقاع وتسلّم بيانات جديدة في موعدها، يوميًا أو أسبوعيًا أو عند التشغيل بأحداث.`)
};

const bn_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নির্দিষ্ট ক্যাডেন্সে চলে এমন স্ক্র্যাপ, সময়মতো ফ্রেশ ডেটা ডেলিভারি: দৈনিক, সাপ্তাহিক বা ইভেন্ট-ট্রিগার্ড।`)
};

const de_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrapes, die im Rhythmus ausgeführt werden und pünktlich, täglich, wöchentlich oder ereignisgesteuert aktuelle Daten liefern.`)
};

const es_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracciones programadas que entregan datos frescos a tiempo, a diario, por semana o por evento.`)
};

const fr_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des extractions programmées qui livrent des données fraîches à l'heure, chaque jour, chaque semaine ou sur événement.`)
};

const pt_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrações programadas que entregam dados frescos no prazo, todo dia, toda semana ou por evento.`)
};

const zh_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按节奏运行并按时、每天、每周或事件触发提供新数据的抓取。`)
};

const tr_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belirli tempoda çalışan, günlük, haftalık ya da olay tetiklemeli taze veri sunan kazımalar.`)
};

const ru_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрапы по расписанию, свежие данные в срок: ежедневно, еженедельно или по событию.`)
};

const pl_svc_web_scraping_sched_desc5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrapery chodzą cyklicznie i dowożą świeże dane na czas: dziennie, tygodniowo lub odpalane eventem.`)
};

/**
* | output |
* | --- |
* | "Scrapes that run on a cadence and deliver fresh data on time, daily, weekly, or event-triggered." |
*
* @param {Svc_Web_Scraping_Sched_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_sched_desc5 = /** @type {((inputs?: Svc_Web_Scraping_Sched_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Sched_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_sched_desc5(inputs)
	if (locale === "bn") return bn_svc_web_scraping_sched_desc5(inputs)
	if (locale === "de") return de_svc_web_scraping_sched_desc5(inputs)
	if (locale === "es") return es_svc_web_scraping_sched_desc5(inputs)
	if (locale === "fr") return fr_svc_web_scraping_sched_desc5(inputs)
	if (locale === "pt") return pt_svc_web_scraping_sched_desc5(inputs)
	if (locale === "zh") return zh_svc_web_scraping_sched_desc5(inputs)
	if (locale === "tr") return tr_svc_web_scraping_sched_desc5(inputs)
	if (locale === "ru") return ru_svc_web_scraping_sched_desc5(inputs)
	if (locale === "pl") return pl_svc_web_scraping_sched_desc5(inputs)
	return en_svc_web_scraping_sched_desc5(inputs)
});
export { svc_web_scraping_sched_desc5 as "svc_web-scraping_SCHED_desc" }